'use strict';

import _ from 'underscore';

export default function HeadlinesController(
  CreativeService,
  HeadlineService,
  $sanitize,
  $scope
) {
  var vm = this;

  vm.service = HeadlineService;
  vm.analyze = analyze;
  vm.creativeService = CreativeService;

  function init() {
    $scope.$watch(headline, _.debounce(analyze, 500));
  }

  function analyze(newVal, oldVal) {
    var newHeadline = headline();
    if (newHeadline && newHeadline.length > 0 && newVal !== oldVal) {
      vm.service.analyze(newHeadline);
    } else {
      vm.service.reset();
    }
  }

  function headline() {
    return CreativeService.creative.headline;
  }

  init();
  return vm;
}

HeadlinesController.$inject = [
  'CreativeService',
  'HeadlineService',
  '$sanitize',
  '$scope'
];
